// Entry de la PWA. Registra service worker, inicializa font scale y monta el router.

import { bindFontScaleCycler, initFontScale } from './components/font-scale.js';
import { defineRoute, navigate, setAdminGuard, setAuthGuard, start } from './router.js';
import { checkSession, getUser, isAdmin } from './state/auth.js';
import { adminView } from './views/admin.js';
import { empaquetadoView } from './views/empaquetado.js';
import { loginView } from './views/login.js';
import { pedidosView } from './views/pedidos.js';
import { setPasswordView } from './views/set-password.js';

initFontScale();
bindFontScaleCycler();

// Service worker — solo en producción (en dev Vite recarga módulos y SW estorba).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err =>
      console.warn('SW no registrado:', err));
  });
}

// Guard: si no hay usuario, intentar /auth/me; si sigue sin haber, denegar.
setAuthGuard(async () => {
  if (getUser()) return true;
  const u = await checkSession();
  return !!u;
});

// Guard de admin: rutas con admin:true requieren role admin tras el authGuard.
setAdminGuard(async () => {
  // Si llegamos aquí, el authGuard ya pasó → getUser() debería estar.
  return isAdmin();
});

// Rutas
defineRoute('#/login',         () => loginView(),                       { auth: false });
defineRoute('#/set-password',  (p, q) => setPasswordView(p, q),         { auth: false });
defineRoute('#/pedidos',       () => pedidosView());
defineRoute('#/pedido/:id',    (params) => empaquetadoView(params));
defineRoute('#/admin',         (_p, query) => adminView({ tab: query.tab || 'productos' }),
                               { auth: true, admin: true });
defineRoute('#/',              async () => {
  // Sin ruta concreta: decide según haya sesión o no.
  const u = await checkSession();
  navigate(u ? '#/pedidos' : '#/login', { replace: true });
  return { mount() {}, unmount() {} };
}, { auth: false });

// Si el client emite `auth:expired`, mandamos a login sin pedir confirmación —
// la cookie ya está rota, no hay nada que recuperar.
window.addEventListener('auth:expired', () => navigate('#/login', { replace: true }));

start(document.getElementById('app'));
